import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireDeepEqual } from '../node_modules/deep-equal/index.js';

var deepEqualExports = requireDeepEqual();
var deepEqual = /*@__PURE__*/getDefaultExportFromCjs(deepEqualExports);

export { deepEqual as default };
